import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../_services';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private _US: UserService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let decryptedData = localStorage.getItem("oneHomeCurrentUser") ? this._US.getDecryptData(localStorage.getItem("oneHomeCurrentUser")) : null;
    // let decryptedData = localStorage.getItem("oneHomeCurrentUser") ? JSON.parse(localStorage.getItem("oneHomeCurrentUser")) : null;
    const allReadyLoggedIn = decryptedData;
    let isAuthenticated = allReadyLoggedIn && allReadyLoggedIn.token ? true : false;
    if (!isAuthenticated) {
      // $('#offcanvasToplogin').offcanvas('show');
      // this.router.navigate(['/']);
      return false;
    }
    return true;
  }

}
